export default __webpack_public_path__ + "static/media/scooter-icon.7be04887.png";